export enum FileStatus {
    New = 0,
    Uploaded = 1,
    Calculated = 2,
}